/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import {
  Paper, Typography, Grid,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import placementTestActions from '../../../redux/actions/placementTestActions';
import placementTestServices from '../../../redux/services/placementTestServices';
import { numGradeToEUgrade, convertCEFRToElearningLevel, withTestSchools } from '../../../helpers/utils';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  cardHeader: {
    backgroundColor: '#1bb1e4',
    color: '#FFF',
    width: '100%',
  },
  cardBody: {
    width: '90%',
    margin: 'auto',
    textAlign: 'center',
    paddingTop: '1em',
  },
  center: {
    textAlign: 'center',
    margin: 'auto',
    width: '90%',
  },
  title: {
    padding: '1em',
    textAlign: 'center',
  },
  subTitle: {
    paddingBottom: '0.5em',
  },
  link: {
    color: '#1bb1e4',
  },
}));
const NoGroupAssociatedCard = ({
  semester, company, _id, clearTest, data,
}) => {
  const classes = useStyles();

  useEffect(() => {
    async function getTest() {
      const test = await placementTestServices.getTest(_id);
      if (test && test.scores) {
        return test.scores.total;
      }
      return 1;
    }
    if (!data || data.length === 0) {
      let level;
      let score;
      if (!withTestSchools.includes(company._id)) {
        level = 1;
      } else {
        score = getTest();
        level = convertCEFRToElearningLevel(numGradeToEUgrade(score));
      }
      placementTestServices.postStudentToGroup(company._id, level, _id, semester)
        .then(
          () => {
            clearTest();
          },
          (error) => {
            console.error(error);
          },
        );
    }
  }, []);

  return (
    <Paper className={classes.root}>
      <Grid container direction="row" className={classes.center}>
        <Grid item lg={12}>
          <Typography variant="body1" className={classes.title} style={{ fontWeight: 900 }}>
            Your course programme isn’t available yet.
          </Typography>
        </Grid>
        <Grid item lg={12}>
          <Typography variant="body1" className={classes.subTitle}>
            Don’t worry, it’s coming soon.
          </Typography>
          <Typography variant="body1" className={classes.subTitle}>
            However, if you think you should already have access to your programme and content, try signing out and signing back in later.  If your course is still inaccessible, please contact
            <Link push to="/help" className={classes.link}>
              help
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

NoGroupAssociatedCard.propTypes = {
  semester: PropTypes.number.isRequired,
  company: PropTypes.object.isRequired,
  _id: PropTypes.string.isRequired,
  clearTest: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};

const actionCreators = {
  clearTest: placementTestActions.clearTest,
};

function mapState(state) {
  const { userData } = state.user;
  const { semester, company, _id } = userData;
  const { data } = state.group;
  return {
    semester, company, _id, data,
  };
}
export default connect(mapState, actionCreators)(NoGroupAssociatedCard);
